module.exports = __webpack_public_path__ + "static/img/规则自动化配置.40d3cb59.png";